/*@ngInject*/
const DynamicDataItemCriterionController = function ($rootScope, $scope, $element, $q, $timeout, dataSetEditorModel,
                                                     configurationConstant, dataSetManagementUtil, localization,
                                                     coreMediator, configurationMediator, type, currentUserModel,
                                                     authorizationConstants, dataSetType) {

    var timeoutList = [],
        shiftSelectPivotId = null;

    $element.addClass('dynamicDataItemCriterion');

    this.$onInit = function () {
        localization.getTranslationByKey('dynamicDataItemCriterion').then(function (translations) {
            this.dataItemPlaceholder = _.get(translations, 'table.dataItemPlaceholder');
            this.productPlaceholder = _.get(translations, 'table.productPlaceholder');
            this.dropdownValuePlaceholder = _.get(translations, 'table.dropdownValuePlaceholder');
            this.textValuePlaceholder = _.get(translations, 'table.textValuePlaceholder');
        }.bind(this));

        this.maxSourceFieldDependencies = configurationConstant.dataSet.MAX_SOURCE_FIELD_DEPENDENCIES;
        this.isReadOnly = !currentUserModel.hasAuthorization(authorizationConstants.MANAGE_DATASETS);

        this.initializeCriteriaViewModel();
    };

    this.initializeCriteriaViewModel = function () {
        var promiseList = [];

        this.dataSet = dataSetEditorModel.getDataSet(this.datasetName);

        if (!_.isNil(this.dataSet)) {
            this.dynamicDataItemCriteriaViews = [];
            this.allProducts = [];
            this.sourceFieldDependencyDataSetItems = [];
            _.each(_.range(0, configurationConstant.dataSet.MAX_SOURCE_FIELD_DEPENDENCIES), function () {
                this.sourceFieldDependencyDataSetItems.push(null);
            }.bind(this));

            promiseList.push(coreMediator.getDynamicDataSetItems({name: 'All Products'}).then(function (items) {
                this.allProducts = items;
            }.bind(this)));

            _.each(this.dataSet.dynamicDataSetDependency.sourceFieldDependencies, function (sourceFieldDependency, index) {
                promiseList.push(this.processSourceFieldDependency(sourceFieldDependency, index));
            }.bind(this));

            $q.all(promiseList).then(function () {
                _.each(this.dataSet.items, function (dataItem) {
                    if (!_.isEmpty(dataItem.enhancedDynamicDataItemCriteriaList)) {
                        _.each(dataItem.enhancedDynamicDataItemCriteriaList, function (dynamicDataItemCriteria) {
                            var dataItemDropdownSelectedValue = _.find(this.dataSet.items, function (dataItem) {
                                    return dynamicDataItemCriteria.value === dataItem.value;
                                }),
                                productDropdownSelectedValue = _.find(this.allProducts, function (product) {
                                    return dynamicDataItemCriteria.productName === product.name;
                                }),
                                fieldValues = this.processFieldValues(dynamicDataItemCriteria),
                                validDataItemDropdownSelectedValue = !_.isNil(dataItemDropdownSelectedValue),
                                validProductDropdownSelectedValue = !_.isNil(productDropdownSelectedValue),
                                dataItemTooltip = validDataItemDropdownSelectedValue ? dataItemDropdownSelectedValue.name : '',
                                productTooltip = validProductDropdownSelectedValue ? productDropdownSelectedValue.name : '';

                            this.dynamicDataItemCriteriaViews.push({
                                id: dataSetManagementUtil.generateUUID(),
                                selected: false,
                                selectable: true,
                                dataItemDropdownSelectedValue: dataItemDropdownSelectedValue,
                                productDropdownSelectedValue: productDropdownSelectedValue,
                                fieldValues: fieldValues,
                                dataItemTooltip: dataItemTooltip,
                                productTooltip: productTooltip,
                                dynamicDataItemCriteria: dynamicDataItemCriteria
                            });
                        }.bind(this));
                    }
                }.bind(this));

                this.sort = 'value';
                this.sortAsc = true;
                this.applySorting();

                if (!this.isReadOnly) {
                    this.addNewRowIfLastRowIsValid();
                }
            }.bind(this));
        }
    };

    this.processSourceFieldDependency = function (sourceFieldDependency, index) {
        if (dataSetManagementUtil.isValidSourceFieldDependency(sourceFieldDependency)) {
            return configurationMediator.getFieldOptions(sourceFieldDependency.formTemplateUniqueName, sourceFieldDependency.fieldName).then(function (result) {
                var dataSetName;

                if (_.size(result) === 1) {
                    result = result[0];
                    dataSetName = result.dataSetName;
                }

                if (!_.isNil(dataSetName)) {
                    return coreMediator.getCachedDataSetByName(dataSetName).then(function (dataSet) {
                        if(dataSet.type === dataSetType.CUSTOM){
                            this.sourceFieldDependencyDataSetItems[index] = null;
                        }
                        else{
                            this.sourceFieldDependencyDataSetItems[index] = dataSet.items;
                        }
                    }.bind(this));
                } else {
                    this.sourceFieldDependencyDataSetItems[index] = null;
                }
            }.bind(this));
        } else {
            return $q.when();
        }
    };

    this.processFieldValues = function (dynamicDataItemCriteria) {
        var fieldValues = [];

        _.each(_.range(0, configurationConstant.dataSet.MAX_SOURCE_FIELD_DEPENDENCIES), function (fieldValueIndex) {
            var fieldValue = dynamicDataItemCriteria['fieldValue' + (fieldValueIndex + 1)],
                dropdownSelectedValue,
                isValidDropdownSelectedValue;

            if (!_.isNil(this.sourceFieldDependencyDataSetItems[fieldValueIndex])) {
                dropdownSelectedValue = _.find(this.sourceFieldDependencyDataSetItems[fieldValueIndex], function (dataItem) {
                    return fieldValue === dataItem.value;
                });
                isValidDropdownSelectedValue = !_.isNil(dropdownSelectedValue);

                fieldValues.push({
                    dropdownSelectedValue: dropdownSelectedValue,
                    tooltip: isValidDropdownSelectedValue ? dropdownSelectedValue.name : ''
                });
            } else {
                fieldValues.push({
                    value: fieldValue,
                    tooltip: fieldValue
                });
            }
        }.bind(this));

        return fieldValues;
    };

    this.removeInvalidRows = function () {
        this.dynamicDataItemCriteriaViews = _.filter(this.dynamicDataItemCriteriaViews, function (dynamicDataItemCriteriaView) {
            return dataSetManagementUtil.isValidDynamicDataItemCriteriaForEvaluation(dynamicDataItemCriteriaView.dynamicDataItemCriteria);
        });
    };

    this.addNewRowIfLastRowIsValid = function () {
        var emptyDynamicDataItemCriteriaViews = this.dynamicDataItemCriteriaViews.length === 0,
            lastRowIsValid = false,
            lastRow;

        if (!emptyDynamicDataItemCriteriaViews) {
            lastRow = _.last(this.dynamicDataItemCriteriaViews);
            lastRowIsValid = dataSetManagementUtil.isValidDynamicDataItemCriteriaForEvaluation(lastRow.dynamicDataItemCriteria);
        }

        if (emptyDynamicDataItemCriteriaViews || lastRowIsValid) {
            this.dynamicDataItemCriteriaViews.push({
                id: dataSetManagementUtil.generateUUID(),
                selected: false,
                selectable: false,
                dataItemDropdownSelectedValue: null,
                productDropdownSelectedValue: null,
                fieldValues: [],
                dataItemTooltip: '',
                productTooltip: '',
                dynamicDataItemCriteria: {
                    dataSetName: this.datasetName,
                    fieldValue1: null,
                    fieldValue2: null,
                    fieldValue3: null,
                    ordering: 0,
                    productName: null,
                    value: null
                }
            });
        }
    };

    this.filterSourceFieldDependencies = function (sourceFieldDependency) {
        return dataSetManagementUtil.isValidSourceFieldDependency(sourceFieldDependency);
    };

    this.filterDataItems = function (dataItem) {
        return dataSetManagementUtil.isValidDataItem(dataItem);
    };

    this.handleDynamicCriteriaChange = function () {
        this.removeInvalidRows();
        _.each(this.dynamicDataItemCriteriaViews, function (dynamicDataItemCriteriaView) {
            dynamicDataItemCriteriaView.selectable = true;
        });
        this.addNewRowIfLastRowIsValid();

        dataSetEditorModel.setUnsavedChanges(this.datasetName, /*hasUnsavedChanges*/true);
        this.validateDynamicDataItemCriterion();
    };

    this.validateDynamicDataItemCriterion = function () {
        var previousValid = dataSetEditorModel.isValidDynamicCriterion(this.datasetName),
            areDynamicCriterionValid = true; // We currently have no necessary validation for dynamic data item criterion, but if/when we do, the helper method can be called here.

        dataSetEditorModel.setValidDynamicCriterion(this.datasetName, areDynamicCriterionValid);

        if (previousValid !== areDynamicCriterionValid) {
            $rootScope.$broadcast(configurationConstant.event.DATA_SET_DYNAMIC_CRITERIA_UPDATED);
        }
    };

    this.onDataItemChange = function (event, dynamicDataItemCriteriaView) {
        var dropdownSelectedValue = dynamicDataItemCriteriaView.dataItemDropdownSelectedValue,
            dataItemValue = !_.isNil(dropdownSelectedValue) ? dropdownSelectedValue.value : null,
            validDataItemDropdownSelectedValue = !_.isNil(dynamicDataItemCriteriaView.dataItemDropdownSelectedValue);

        dynamicDataItemCriteriaView.dataItemTooltip = validDataItemDropdownSelectedValue ? dynamicDataItemCriteriaView.dataItemDropdownSelectedValue.name : '';

        dataSetEditorModel.moveDynamicDataItemCriteria(this.datasetName, dynamicDataItemCriteriaView.dynamicDataItemCriteria, dataItemValue);

        if (this.sort === 'value') {
            this.changeSort('');
        }

        this.handleDynamicCriteriaChange();
    };

    this.onProductDependencyChange = function (event, dynamicDataItemCriteriaView) {
        var dropdownSelectedValue = dynamicDataItemCriteriaView.productDropdownSelectedValue,
            validProductDropdownSelectedValue = !_.isNil(dynamicDataItemCriteriaView.productDropdownSelectedValue);

        dynamicDataItemCriteriaView.productTooltip = validProductDropdownSelectedValue ? dynamicDataItemCriteriaView.productDropdownSelectedValue.name : '';

        dynamicDataItemCriteriaView.dynamicDataItemCriteria.productName = !_.isNil(dropdownSelectedValue) ? dropdownSelectedValue.name : null;

        if (this.sort === 'productName') {
            this.changeSort('');
        }

        this.handleDynamicCriteriaChange();
    };

    this.onFieldDependencyDropdownChange = function (event, dynamicDataItemCriteriaView, index) {
        var dropdownSelectedValue = dynamicDataItemCriteriaView.fieldValues[index].dropdownSelectedValue,
            value = !_.isNil(dropdownSelectedValue) ? dropdownSelectedValue.value : null,
            tooltip = !_.isNil(dropdownSelectedValue) ? dropdownSelectedValue.name : '';

        updateFieldDependencyModel(dynamicDataItemCriteriaView, index, value, tooltip);

        if (this.sort === 'fieldValue' + (index + 1)) {
            this.changeSort('');
        }

        this.handleDynamicCriteriaChange();
    };

    this.onFieldDependencyTextInputBlur = function (event, dynamicDataItemCriteriaView, index) {
        var value;

        if (!_.isNil(dynamicDataItemCriteriaView.fieldValues[index])) {
            value = dynamicDataItemCriteriaView.fieldValues[index].value;

            updateFieldDependencyModel(dynamicDataItemCriteriaView, index, value, /*tooltip*/value);

            if (this.sort === 'fieldValue' + (index + 1)) {
                this.changeSort('');
            }

            this.handleDynamicCriteriaChange();
        }
    };

    function updateFieldDependencyModel(dynamicDataItemCriteriaView, index, value, tooltip) {
        dynamicDataItemCriteriaView.dynamicDataItemCriteria['fieldValue' + (index + 1)] = _.isEmpty(value) ? null : value;

        dynamicDataItemCriteriaView.fieldValues[index].tooltip = tooltip;
    }

    this.changeSort = function (sortLabel) {
        if (this.sort === sortLabel) {
            this.sortAsc = !this.sortAsc;
        } else {
            this.sort = sortLabel;
            this.sortAsc = true;
        }

        this.applySorting();
    };

    this.applySorting = function () {
        if (!this.isReadOnly) {
            this.removeInvalidRows();
        }

        this.dynamicDataItemCriteriaViews = _.orderBy(this.dynamicDataItemCriteriaViews, 'dynamicDataItemCriteria.' + this.sort, this.sortAsc ? 'asc' : 'desc');

        if (!this.isReadOnly) {
            this.addNewRowIfLastRowIsValid();
        }

        // Update the transient view ordering property to allow for shift-select
        _.each(this.dynamicDataItemCriteriaViews, function (dynamicDataItemCriteriaView, index) {
            dynamicDataItemCriteriaView.ordering = index;
        });
    };

    this.onDynamicDataItemCriteriaSelected = function (event, dynamicDataItemCriteriaView) {
        var isValidDynamicDataItemCriteria,
            shiftSelectPivot = null;

        if (event.button === 0) { // Left click only
            isValidDynamicDataItemCriteria = dataSetManagementUtil.isValidDynamicDataItemCriteriaForEvaluation(dynamicDataItemCriteriaView.dynamicDataItemCriteria);

            if (event.ctrlKey) {
                dynamicDataItemCriteriaView.selected = !dynamicDataItemCriteriaView.selected;
            } else if (event.shiftKey) {
                if (!_.isNil(shiftSelectPivotId)) {
                    shiftSelectPivot = _.find(this.dynamicDataItemCriteriaViews, function (dynamicDataItemCriteriaView) {
                        return dynamicDataItemCriteriaView.id === shiftSelectPivotId;
                    });
                }

                if (_.isNil(shiftSelectPivot)) {
                    if (isValidDynamicDataItemCriteria) {
                        dynamicDataItemCriteriaView.selected = true;
                        shiftSelectPivotId = dynamicDataItemCriteriaView.id;
                    }
                } else {
                    if (dynamicDataItemCriteriaView.ordering < shiftSelectPivot.ordering) {
                        _.each(this.dynamicDataItemCriteriaViews, function (itemView) {
                            var isValid = dataSetManagementUtil.isValidDynamicDataItemCriteriaForEvaluation(itemView.dynamicDataItemCriteria);

                            if (isValid &&
                                itemView.ordering >= dynamicDataItemCriteriaView.ordering &&
                                itemView.ordering <= shiftSelectPivot.ordering) {
                                itemView.selected = true;
                            } else {
                                itemView.selected = false;
                            }
                        });
                    } else if (dynamicDataItemCriteriaView.ordering > shiftSelectPivot.ordering) {
                        _.each(this.dynamicDataItemCriteriaViews, function (itemView) {
                            var isValid = dataSetManagementUtil.isValidDynamicDataItemCriteriaForEvaluation(itemView.dynamicDataItemCriteria);

                            if (isValid &&
                                itemView.ordering >= shiftSelectPivot.ordering &&
                                itemView.ordering <= dynamicDataItemCriteriaView.ordering) {
                                itemView.selected = true;
                            } else {
                                itemView.selected = false;
                            }
                        });
                    } else {
                        _.each(this.dynamicDataItemCriteriaViews, function (itemView) {
                            itemView.selected = false;
                        });

                        dynamicDataItemCriteriaView.selected = true;
                    }
                }
            } else {
                if (isValidDynamicDataItemCriteria) {
                    _.each(this.dynamicDataItemCriteriaViews, function (itemView) {
                        itemView.selected = false;
                    });

                    dynamicDataItemCriteriaView.selected = true;
                    shiftSelectPivotId = dynamicDataItemCriteriaView.id;
                }
            }
        }
    };

    this.onDynamicCriteriaFocused = function () {
        _.each(this.dynamicDataItemCriteriaViews, function (dynamicDataItemCriteriaView) {
            dynamicDataItemCriteriaView.selected = false;
        });

        shiftSelectPivotId = null;
    };

    this.handleDeleteKeyEventAction = function () {
        timeoutList.push($timeout(function () {
            this.deleteSelectedDynamicCriteria();
        }.bind(this), 0));
    };

    this.deleteSelectedDynamicCriteria = function () {
        _.each(this.dynamicDataItemCriteriaViews, function (dynamicDataItemCriteriaView) {
            if (dynamicDataItemCriteriaView.selected) {
                // To delete a criteria, we remove all it's dependencies (except the data item it's associated with), and then 'move' it using the model
                // function, to trigger it to be unlinked from the model
                // We then trigger the usual code to cleanup the invalid rows.
                dynamicDataItemCriteriaView.dynamicDataItemCriteria.productName = null;
                _.each(_.range(1, configurationConstant.dataSet.MAX_SOURCE_FIELD_DEPENDENCIES + 1), function (fieldValueIndex) {
                    dynamicDataItemCriteriaView.dynamicDataItemCriteria['fieldValue' + fieldValueIndex] = null;
                });

                dataSetEditorModel.moveDynamicDataItemCriteria(this.datasetName, dynamicDataItemCriteriaView.dynamicDataItemCriteria, /*destinationDataItemValue*/null);
            }
        }.bind(this));

        this.handleDynamicCriteriaChange();

        shiftSelectPivotId = null;
    };

    $scope.$on(configurationConstant.event.DATA_SET_EDITOR_MODEL_UPDATED, function (event, dataSetName) {
        if (this.datasetName === dataSetName) {
            this.initializeCriteriaViewModel();
        }
    }.bind(this));

    $scope.$on(configurationConstant.event.DATA_SET_SOURCE_FIELD_DEPENDENCY_UPDATED, function () {
        var promiseList = [];

        _.each(this.dataSet.dynamicDataSetDependency.sourceFieldDependencies, function (sourceFieldDependency, index) {
            promiseList.push(this.processSourceFieldDependency(sourceFieldDependency, index));
        }.bind(this));

        $q.all(promiseList).then(function () {
            // Re-evaluate the 'fieldValues' view attached to each dynamicDataItemCriteriaView to make sure everything is still in sync
            _.each(this.dynamicDataItemCriteriaViews, function (dynamicDataItemCriteriaView) {
                dynamicDataItemCriteriaView.fieldValues = this.processFieldValues(dynamicDataItemCriteriaView.dynamicDataItemCriteria);
            }.bind(this));
        }.bind(this));
    }.bind(this));

    $scope.$on('$destroy', function () {
        _.each(timeoutList, function (item) {
            $timeout.cancel(item);
        });
    });
};

angular.module('ums.configuration')
    .controller('dynamicDataItemCriterionController', DynamicDataItemCriterionController);
